<script>
import SectionCard from '../SectionCard.vue';

export default {
  name: 'LocationSection',
  components: { SectionCard },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // `??` inside a template expression fails Vue 2's template-to-render
    // compiler here (separate parser from Babel, doesn't support ES2020
    // syntax) — compute the fallback in script instead.
    latitudeLabel() {
      return this.project.latitude != null ? this.project.latitude : '—';
    },
    longitudeLabel() {
      return this.project.longitude != null ? this.project.longitude : '—';
    },
  },
};
</script>

<template>
  <SectionCard section-id="location" :title="$t('REAL_ESTATE.LOCATION.TITLE')">
    <template #action>
      <woot-button
        variant="clear"
        size="small"
        icon="edit"
        @click="$emit('edit')"
      >
        {{ $t('REAL_ESTATE.LOCATION.EDIT_BUTTON') }}
      </woot-button>
    </template>

    <dl class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
      <div>
        <dt class="text-slate-400">{{ $t('REAL_ESTATE.LOCATION.AREA') }}</dt>
        <dd class="text-slate-900 dark:text-slate-100">
          {{ project.area || '—' }}
        </dd>
      </div>
      <div>
        <dt class="text-slate-400">
          {{ $t('REAL_ESTATE.LOCATION.LOCATION_LABEL') }}
        </dt>
        <dd class="text-slate-900 dark:text-slate-100">
          {{ project.region || '—' }}
        </dd>
      </div>
      <div class="sm:col-span-2">
        <dt class="text-slate-400">{{ $t('REAL_ESTATE.LOCATION.ADDRESS') }}</dt>
        <dd class="text-slate-900 dark:text-slate-100">
          {{ project.address || '—' }}
        </dd>
      </div>
      <div>
        <dt class="text-slate-400">
          {{ $t('REAL_ESTATE.LOCATION.LATITUDE') }}
        </dt>
        <dd class="text-slate-900 dark:text-slate-100">
          {{ latitudeLabel }}
        </dd>
      </div>
      <div>
        <dt class="text-slate-400">
          {{ $t('REAL_ESTATE.LOCATION.LONGITUDE') }}
        </dt>
        <dd class="text-slate-900 dark:text-slate-100">
          {{ longitudeLabel }}
        </dd>
      </div>
    </dl>
  </SectionCard>
</template>
